"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePageDuplication = exports.validatePageCreation = exports.validateApiConstructor = exports.validateSettings = exports.validateAttributes = void 0;
function validateAttributes(attributeList) {
    if (!Array.isArray(attributeList)) {
        throw new Error('Invalid attribute list');
    }
    return (attributes) => attributeList.forEach((parameter) => {
        if (typeof attributes[parameter] !== 'undefined')
            return;
        throw new Error(`The attribute "${parameter}" is required`);
    });
}
exports.validateAttributes = validateAttributes;
exports.validateSettings = validateAttributes([
    'bookId',
    'baseUrl',
    'credentials',
]);
exports.validateApiConstructor = validateAttributes([
    'baseUrl',
    'bookId',
    'credentials',
]);
exports.validatePageCreation = validateAttributes([
    'height',
    'page_number',
    'unit',
    'width',
]);
exports.validatePageDuplication = validateAttributes([
    'append',
    'based_on',
]);
//# sourceMappingURL=errorHandler.js.map